// @flow

import { rem } from 'polished';
import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

// import Translate from 'client/components/translate';
import COLORS, { HEX_TRANSPARENT } from 'client/constants/colors';
import Ribbon from 'client/components/plan/card/ribbon';
import { CARD_ICON_IMAGE_URLS } from 'client/components/plan/constants/cardIcons';
import { DetailsContainer, IconAndDetailsFlexRow } from 'client/components/plan/shared/card';
// import PlanCard from 'client/components/plan/card/planCard';
import TypeAndDate from 'client/components/plan/card/typeAndDate';
import 'client/styles/planCard.scss';
import 'client/styles/ribbon.scss';

const CompactAppCardContainer = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: ${rem(12)};
  box-shadow: 0 ${rem(2)} ${rem(10)} 0 ${`${COLORS.GRAY_7}${HEX_TRANSPARENT[50]}`};
  color: ${COLORS.NEUTRAL_900};
  cursor: pointer;
  letter-spacing: 0;
  padding-bottom: 1.5rem;
  img {
    margin-right: ${rem(10)};
    max-height: 1.5rem;
    min-width: ${rem(29)};
  }
`;

const CompactRibbonContainer = styled.div`
  padding-top: 0.5rem;
  text-align: right;
`;

const CompactViewCardCarrierNameContainer = styled.div`
  font-size: 1rem;
  line-height: ${rem(22)};
`;

const CompactViewCardPlanNameContainer = styled.div`
  font-size: ${rem(14)};
  font-weight: 300;
  line-height: ${rem(19)};
`;

type Props = {
  className: string,
  clickHandler: Function,
  isCard: boolean,
  // isCompactView: boolean,
  status: {
    content: string,
    className: Object,
    translationPath: string,
  } | null,
  plan: Object,
};

export const Phase3AppCard = (props: Props) => {
  const { className, isCard, status, plan, clickHandler } = props;
  return (
    <div
      className={cx('plan-card', 'margin', { wrapped: !isCard }, className)}
      onClick={clickHandler}>
      <CompactAppCardContainer>
        {status && (
          <CompactRibbonContainer>
            <Ribbon
              className={status.className}
              classes={{ className: status.className }}
              content={status.translationPath}
              isCompactRibbon
              wrapAround />
          </CompactRibbonContainer>
        )}
        {/* {isCompactView ? ( */}
        <IconAndDetailsFlexRow onClick={clickHandler}>
          <div className="flex-row start">
            <img alt="health" src={CARD_ICON_IMAGE_URLS.health} />
            <DetailsContainer>
              <TypeAndDate shouldLabelAsInsurance type="health" />
              <CompactViewCardCarrierNameContainer>
                {plan.carrier}
              </CompactViewCardCarrierNameContainer>
              <CompactViewCardPlanNameContainer>{plan.planName}</CompactViewCardPlanNameContainer>
            </DetailsContainer>
          </div>
          <DetailsContainer>
            <span className="icon-right-open-big neutral-text-color bold" />
          </DetailsContainer>
        </IconAndDetailsFlexRow>
      </CompactAppCardContainer>

      {/* ) : (
          <div className="row card-top-padding" style={{ position: 'relative' }}>
            {status && (
              <div className="ribbon-container">
                <Ribbon
                  content={status.translationPath}
                  className={status.className}
                  wrapAround={isCard} />
                <div className="show-for-new-hub-page">
                  <div className="hide-for-small-only flex-row text-right pad-top pad-right-2">
                    <Translate
                      path={`common.label.metalTypes.${plan.metalType}`}
                      using={{ planType: plan.planType }}
                      className="font-size-14" /> */}
      {/* <div className="flex-row">
                      <PlanTypeIcon metalType={plan.metalType} />
                    </div> */}
      {/* </div>
                </div>
              </div>
            )}
          </div>
        )} */}
    </div>
  );
};
